<script>
export default {
  name: 'Button',
};
</script>

<template>
<div class="button">
    <slot></slot>
</div>
</template>

<style scoped lang="scss">
.button {
    cursor: pointer;
    box-sizing: border-box;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 12px 16px;

    border: 1px solid #E4E4E4;
    border-radius: 6px;

    flex: none;
    order: 0;
    flex-grow: 0;
    color: #020617;

    font-family: Geist, sans-serif;
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 0;
    text-align: center;


    /*transition: all 0.2s ease;*/
}

/*.button:hover {
    padding: 14px 18px; !* збільшено на 2px *!
}*/
</style>
